// console.log('process.env.devSubdomains from inside file::', JSON.parse(process.env.devSubdomains));

function isDevSubdomain(hostName) {
  // console.log('process.env.devSubdomains', process.env.devSubdomains);
  if (
    hostName.split('.').length === 3
    && process.env.devSubdomains.indexOf(hostName.split('.')[0]) > -1
  ) {
    return true;
  }
  return false;
}

function getCookieDomain() {
  const hostName = window.location.hostname;

  if (isDevSubdomain(window.location.hostname)) {
    return window.location.hostname;
  }

  const domainName = hostName.replace(/([^\.]*\.){1}/, '');

  return domainName;
}

function getCookieHelper(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function getCookie(name) {
  const x = getCookieHelper(name);
  return x && (x === 'null' ? undefined : decodeURIComponent(x));
}

export function setATACookie(userId, at) {
  if (!userId || !at) {
    console.log('uid:', userId, 'at:', at, '  ::  NOT VALID, not adding to orgs');
    return false;
  }

  let atCookieArr = [];
  const atCookie = getCookie('at_i_a');
  if (atCookie && atCookie.length > 0) {
    atCookieArr = JSON.parse(atCookie);
  }
  const e = {};
  e[userId] = at;
  let found = false;
  atCookieArr.forEach((uat, i) => {
    if (Object.keys(uat)[0] === userId) {
      atCookieArr[i] = e;
      found = true;
    }
  });
  if (!found) {
    atCookieArr.push(e);
  }

  const currentMillis = new Date().getTime() + 100 * 60 * 60 * 1000;
  const utcDate = new Date(currentMillis).toUTCString();
  const cookieDomainName = getCookieDomain();
  document.cookie = 'at_i_a='
    + JSON.stringify(atCookieArr)
    + ';domain=.'
    + cookieDomainName
    + ';expires='
    + utcDate;
}

export function removeATACookie(userId) {
  let atData = getCookie('at_i_a');
  if (atData) {
    atData = JSON.parse(atData);
  }

  if (Array.isArray(atData) && atData.length > 0) {
    let tokenIndex = -1;
    atData.forEach((uat, i) => {
      if (Object.keys(uat)[0] === userId) {
        tokenIndex = i;
      }
    });
    if (tokenIndex > -1) {
      atData.splice(tokenIndex, 1);
    }
    const currentMillis = new Date().getTime() + 100 * 60 * 60 * 1000;
    const utcDate = new Date(currentMillis).toUTCString();
    const cookieDomainName = getCookieDomain();
    document.cookie = 'at_i_a=' + JSON.stringify(atData) + ';domain=.' + cookieDomainName + ';expires=' + utcDate;
  }
}
